import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function BitExchangeSettings() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to combined view with settings page selected
    const dataParam = searchParams.get('data');
    const themeParam = searchParams.get('theme') || 'light';
    
    if (dataParam) {
      navigate(`/templates/bitexchange/combined?data=${dataParam}&theme=${themeParam}&page=settings`, { replace: true });
    } else {
      navigate('/templates/bitexchange', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-purple-900 flex items-center justify-center text-white">
      Загрузка...
    </div>
  );
}
